import getClient from 'pobble-components/dist/api-client'

const API_ROOT = process.env.REACT_APP_ENV
  ? `https://${process.env.REACT_APP_ENV === 'stg' ? `stg-` : ''}api.pobble.com/`
  : `http://localhost:3000/`

export default getClient({ baseUrl: API_ROOT })



// WEBPACK FOOTER //
// ./components/api.js